<template>
	<channel :sex=-1></channel>
</template>
<script>
import channel from "@/components/index/channel";
export default {
  name: "woman",
  components: {
    channel
  }
};
</script>


// WEBPACK FOOTER //
// src/components/index/woman.vue